import React, { useEffect, useState, ChangeEvent, useRef } from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Input from '../../input'
import { useTranslation } from 'react-i18next'
import { useWindowSize } from '../../../helpers/hooks/hookWindowsSize'
import { ChromePicker } from 'react-color'
import QRCode from 'qrcode.react'
import { lock } from '../../../images'
import { toast } from 'react-toastify'
import { t } from 'i18next'

interface EditQrProps {
  onSubmit: (values: EditQrValues) => void
  children?: React.ReactNode
  data: EditQrValues
  handleClose: (close: boolean) => void
}

interface EditQrValues {
  _id: string
  title: string
  qr_code: {
    color: string
    logo: string
  }
  short_url: string
  custom_code: string
  original_url: string
  domain: string
}

const InnerForm: React.FunctionComponent<
  EditQrProps & FormikProps<EditQrValues>
> = ({
  values,
  handleChange,
  touched,
  data,
  handleClose,
}) => {

  const { color, logo } = data.qr_code
  const [seletedColor, setSelectedColor] = useState(color)
  const [showPaletteColor, setShowPaletteColor] = useState(false)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [deleteLogo, setDeleteLogo] = useState<boolean>(false)
  const sizeWidth = useWindowSize().width
  const { t } = useTranslation()
  let newLogo =
    !previewUrl && deleteLogo ? null : !previewUrl ? logo : previewUrl

  useEffect(() => {
    if (newLogo) values.qr_code.logo = newLogo
  }, [newLogo])

  useEffect(() => {
    values.qr_code.color = seletedColor
  }, [seletedColor])

  const handleQRCodeClick = () => {
    setShowPaletteColor(!showPaletteColor)
  }

  const handleColorChange = (selectedColor: {
    hex: React.SetStateAction<string>
  }) => {
    setSelectedColor(selectedColor.hex)
  }

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDeleteLogo(false)
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0]

      const imageUrl = URL.createObjectURL(file)
      setPreviewUrl(imageUrl)
    }
  }
  const handleDeletelogo = () => {
    setDeleteLogo(true)
    setPreviewUrl(null)
  }

  const handleCancelClick = () => {
    handleClose(false)
  }

  return (
    <>
      <div className='container-form'>
        <Form>
          <div className='container-form-qr'>
            <div className='container-create-url'>
              <Input
                id='title'
                label={`${t('TITLE')}`}
                type='text'
                value={values.title}
                onChange={handleChange}
                touched={touched.title}
                classNameInput='input'
                placeholder={`${t('TITLE')}`}
                className='col-12'
                classNameLabel='color-primary'
              />
              <div className='d-grid'>
                <div className='d-flex'>
                  <span className='color-primary px-2'>{`${data.short_url}`}</span>
                  <img src={lock} alt={`${t('QR_CODE_UPDATE_INFO')}`} />
                </div>
                <span className='small'>{`${t('QR_CODE_UPDATE_INFO')}`}</span>
              </div>
            </div>

            <div>
              <div className='d-flex position-relative'>
                <button
                  type='button'
                  className='button-select-color'
                  style={{ backgroundColor: seletedColor }}
                  onClick={handleQRCodeClick}
                ></button>
                <Input
                  id='color'
                  label={`${t('QR_CODE_EDIT')}`}
                  classNameLabel='color-black'
                  type='text'
                  value={values.qr_code.color}
                  onChange={handleChange}
                  touched={touched.qr_code?.color}
                  classNameInput='input'
                  className='col-12 col-md-6'
                  customClass='input-select-qr-code'
                />
              </div>

              {showPaletteColor && (
                <ChromePicker
                  color={seletedColor}
                  onChange={handleColorChange}
                />
              )}
              <span className='small'>{`${t('QR_WARNING_CREATION')}`}</span>
            </div>

            {/* <div className='py-4'>
              <span className='bolder'>{`${t('EDIT_LOGO')}`}</span>
              <div className='align-items-center container-flex-grid mt-4'>
                <button
                  type='button'
                  className='button-sixth width-150'
                  onClick={handleButtonClick}
                >{`${t('UPLOAD_YOUR_LOGO')}`}</button>

                <input
                  type='file'
                  accept='image/*'
                  ref={fileInputRef}
                  className='input-file'
                  onChange={handleFileChange}
                  id='qrLogo'
                  name='qrLogo'
                />
                <span
                  className={`${
                    sizeWidth > 768 ? 'padding-left-2' : ''
                  } small col-12 col-md-8`}
                >{`${t('QR_CODE_LOGO_INFO')}`}</span>
              </div>
              <button
                type='button'
                className={`${
                  sizeWidth > 768 ? 'padding-left-4' : ''
                } button-transparent-menu color-primary bolder`}
                onClick={handleDeletelogo}
              >{`${t('DELETE')}`}</button>
            </div> */}

            <div>
              <div className='d-grid'>
                <span className='bolder'>{`${t('PREVIEW')}`}</span>
                <span className='small'>{`${t('PREVIEW_QR_CODE')}`}</span>
              </div>
              <div className='container-flex-block align-items-center'>
                <div className='container-qr-code'>
                  {newLogo ? (
                    <QRCode
                      value={data.short_url}
                      fgColor={seletedColor}
                      size={130}
                      bgColor='transparent'
                      level='H'
                      imageSettings={{
                        src: newLogo,
                        height: 20,
                        width: 20,
                        excavate: true,
                      }}
                    />
                  ) : (
                    <QRCode
                      value={data.short_url}
                      fgColor={seletedColor}
                      size={130}
                      bgColor='transparent'
                      level='H'
                    />
                  )}
                </div>
                <span
                  className={`${
                    sizeWidth > 768 ? 'padding-left-2' : ''
                  } small col-12 col-md-6`}
                >{`${t('QR_CODE_CHARACTERISTICS')}`}</span>
              </div>
            </div>
          </div>

          <div className='container-butttons-general-right'>
            <button
              className='button-third margin-right-2'
              type='button'
              onClick={handleCancelClick}
            >
              {`${t('CANCEL')}`}
            </button>
            <button className='button-first' type='submit'>
              {`${t('SAVE')}`}
            </button>
          </div>
        </Form>
      </div>
    </>
  )
}

const EditQrForm = withFormik<EditQrProps, EditQrValues>({
  mapPropsToValues: (props: any) => {
    const initialValues: EditQrValues = {
      _id: props.data._id,
      short_url: props.data.short_url,
      custom_code: props.data.custom_code,
      original_url: props.data.original_url,
      domain: props.data.domain,
      title: props.data.title,
      qr_code: {
        color: props.data.qr_code.color,
        logo: props.data.qr_code.logo,
      },
    }
    return { ...initialValues, ...props, touched: { qr_code: {} } }
  },

  handleSubmit(values: EditQrValues, { props }: any) {
    const hexRegex = /^#([A-Fa-f0-9]{3}){1,2}$/
    if (hexRegex.test(values.qr_code.color)) {
      props.onSubmit(values)
    } else {
      toast(`${t('ERROR_HEXADECIMAL_COLOR')}`)
    }
  },
})(InnerForm)
export default EditQrForm
